<template>
  <div>
    <el-row>
      <el-col :span="6" :offset="18">
        <el-input v-model="search" placeholder="搜索" @change="getDatas">
          <el-button slot="append" icon="el-icon-search" @click="getDatas"></el-button>
        </el-input>
      </el-col>
    </el-row>
    <el-table
      :data="tables"
      :default-sort="{prop: 'id', order: 'descending'}"
      tooltip-effect="light"
      style="width: 100%"
    >
      <el-table-column align="center" prop="name" label="帐号"></el-table-column>
      <el-table-column align="center" prop="alias" label="昵称"></el-table-column>
     <el-table-column align="center" prop="role" label="角色" :formatter="roleNames"></el-table-column>
     <el-table-column align="center" prop="status" label="状态" :formatter="statusName"></el-table-column>
      <el-table-column align="center" prop="createTime" label="创建时间"></el-table-column>
     <!-- <el-table-column align="center" label="创建时间" prop="createTime">
       <template slot-scope="scope">
         {{new Date(scope.row.createTime).Format('yyyy/MM/dd hh:mm:ss')}}
       </template>
     </el-table-column> -->
      <el-table-column align="center" label="操作" width="300px" v-if="listOperations.length > 0">
        <template slot-scope="scope">
          <el-button v-if="listOperations.some(func => func.name.includes('reset'))"
            size="mini"
            type="primary"
            @click="resetPwd(scope.row)"
          >重置密码
          </el-button>
          <el-button v-if="listOperations.some(func => func.name.includes('edit'))"
            size="mini"
            type="primary"
            @click="edit(scope.row)"
          >编辑
          </el-button>

          <!-- <el-button
              size="mini"
              type="primary"
              @click="authorityEdit(scope.row)"
          >权限配置</el-button> -->

          <el-button v-if="listOperations.some(func => func.name.includes('del'))"
            size="mini"
            type="danger"
            @click="delConfirm(scope.row)"
          >删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination
      class="fy"
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10,20,30,40]"
      :page-size="pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalElement"
    ></el-pagination>

    <user-edit v-if="showUserEdit" :visible="showUserEdit" :currentRow="currentRow"
               @userEditCallback="userEditCallback"/>

    <!-- <el-dialog v-if="showAuthorityEdit" :visible="showAuthorityEdit"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="cancel">
        <authority :params="params"/>
        <el-row style="margin-top: 15px;text-align:center;">
            <el-button type="primary" @click="save">保存</el-button>
            <el-button @click="cancel">取消</el-button>
        </el-row>
    </el-dialog> -->

  </div>
</template>
<script>
  import {mapState, mapMutations} from 'vuex';
  import {Loading} from "element-ui"
  import UserEdit from './UserEdit'
  import Authority from '../role/Authority'

  export default {
    components: {UserEdit, Authority},
    data: vm => ({
      tables: [], //列表数据
      search: null, //搜索关键字
      currentPage: 1,
      pageSize: 10,
      totalElement:0,
      showUserEdit: false,
      currentRow: [],
      showAuthorityEdit: false,
      params: {}
    }),
    computed: {
      // totalElement() {
      //   return this.tables.length
      // },
      ...mapState(['currentMenu', 'listOperations', 'currentMenuOperations']),
    },
    created() {
      this.getListOperations('user');
      if (!this.currentMenu) {
        return
      }
      this.getDatas()
    },
    methods: {
      ...mapMutations(['getListOperations']),
      resetPwd(row){
        this.$axios
          .get(this.baseUrl3 + "user/reset/passwd/" + row.name)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.$message.success(msg);
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
      statusName(row) {
        return row.status ? '启用' : '禁用'
      },
      roleNames(row) {
        let names = [];
        if (row.roleDtos) {
          row.roleDtos.forEach(role => {
            names.push(role.name)
          })
        }
        return names.join(',')
      },
      getDatas() {
        let loading = Loading.service({
          fullscreen: true,
          text: "数据加载中..."
        });
        this.$axios
          .get(this.baseUrl3 + "user/findByPageLike/"
            + this.currentPage + '/'
            + this.pageSize + '/'
            + (this.search ? this.search : null)
          )
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.tables = data.list;
              this.totalElement = data.total
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
            loading.close();
          })
          .catch(error => {
            loading.close();
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
      edit(row) {

        // this.currentUserIid = row.id;
        this.currentRow = row;
        this.showUserEdit = true
      },
      authorityEdit(row) {
        this.params = row;
        this.showAuthorityEdit = true
      },
      del(row) {
        this.$axios
          .get(this.baseUrl3 + "user/del/" + row.id)
          .then(({data: {msg, data, code}}) => {
            if (code == 20000) {
              this.$message.success('操作成功');
              this.getDatas()
            } else {
              this.$message({showClose: true, message: msg, type: "error"});
              console.log(msg);
            }
          })
          .catch(error => {
            this.$message({
              showClose: true,
              message: "系统异常",
              type: "error"
            });
            console.log(error);
          });
      },
      delConfirm(row) {
        this.$confirm('您确认要删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          this.del(row)
        }).catch(() => {

        });
      },
      handleSizeChange(val) {
        this.pageSize = val
        this.getDatas()
      },
      handleCurrentChange(val) {
        this.currentPage = val
        this.getDatas()
      },
      userEditCallback(val) {
        this.showUserEdit = false

        if (val) {
          this.getDatas()
        }
      },
      save() {
        this.cancel()
      },
      cancel() {
        this.showAuthorityEdit = false
      },
    }
  }
</script>
